import { render, staticRenderFns } from "./memberCollectionPol.vue?vue&type=template&id=ab0aede0&scoped=true"
import script from "./memberCollectionPol.vue?vue&type=script&lang=js"
export * from "./memberCollectionPol.vue?vue&type=script&lang=js"
import style0 from "./memberCollectionPol.vue?vue&type=style&index=0&id=ab0aede0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0aede0",
  null
  
)

export default component.exports